import { render, staticRenderFns } from "./CajaContrasena.vue?vue&type=template&id=61b155c6"
import script from "./CajaContrasena.vue?vue&type=script&lang=js"
export * from "./CajaContrasena.vue?vue&type=script&lang=js"
import style0 from "./CajaContrasena.vue?vue&type=style&index=0&id=61b155c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports